import type { FC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { EntityCard } from '@xing-com/crate-x4e-entity-card';
import type { MarkerProps, MarkerVariant } from '@xing-com/marker';

import type { TopCompany } from '../../types';

import { TopCompanyCardSkeleton } from './top-company-card.skeleton';

type TopCompanyCardSubcomponents = {
  Skeleton: typeof TopCompanyCardSkeleton;
};

type TopCompanyCardProps = {
  item: TopCompany;
};

export const TopCompanyCard: FC<TopCompanyCardProps> &
  TopCompanyCardSubcomponents = ({ item }) => {
  const intl = useIntl();
  const markers: MarkerProps[] = [
    ...(item.hasOpenJobs
      ? [
          {
            children: <FormattedMessage id="CP_HIRING" />,
            variant: 'highlight' as MarkerVariant,
            ellipsis: true,
          },
        ]
      : []),
  ];
  const description = undefined;

  const sencondCopy = item.location
    ? `${item.location}, ${item.size}`
    : item.size;
  const descriptionIcon = undefined;
  return (
    <EntityCard
      headline={item.name}
      to={item.companyUrl}
      size="large"
      markers={markers}
      profileImage={{
        // @ts-expect-error FIXME: SC6
        name: item.name,
        profileName: item.name,
        src: item.profileImageUri,
      }}
      copy1={item.industry}
      copy2={sencondCopy}
      description={description}
      descriptionIcon={descriptionIcon}
      button={{
        children: intl.$t(
          {
            id:
              item.jobsCount && item.jobsCount === 1
                ? 'CP_TOP_COMPANIES_CARD_BUTTON.one'
                : 'CP_TOP_COMPANIES_CARD_BUTTON.other',
          },
          { value: item.jobsCount }
        ),
        to: item.jobsUrl,
      }}
    />
  );
};

TopCompanyCard.Skeleton = TopCompanyCardSkeleton;
